import React from "react";
import { STEP_TITLES } from "../../../AllUsersLayout.tsx/utils/constants";
import CloseIcon from "../../../../../../assets/svg/close-icon";
import CompletedIcon from "../../../../../../assets/svg/completed-icon";

interface UserDetailsStepProps {
  createUserStep: number;
  filledStep: number;
  isAgent: boolean;
  handleCloseDrawer: () => void;
  handleStepBack: (step: number) => void;
}

export const UserDetailsStep = ({
  createUserStep,
  filledStep,
  isAgent,
  handleCloseDrawer,
  handleStepBack,
}: UserDetailsStepProps) => {
  // A non-agent user is created from the Assign Role step, so they never reach "Agent Details" —
  // the last entry is agent-only.
  const stepTitles = isAgent ? STEP_TITLES : STEP_TITLES?.slice(0, 2);

  const handleStepBackClick = (step: number) => {
    if (filledStep >= step) {
      handleStepBack(step);
    }
  };

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center justify-between">
        {stepTitles?.map((step, index) => (
          <React.Fragment key={step?.step}>
            <div
              className={`flex items-center gap-[5px] px-1.5 py-1 rounded-md cursor-pointer ${
                filledStep >= step?.step
                  ? "border border-verba-green-success dark:border-verba-green-success-dk"
                  : createUserStep === step?.step
                  ? "border border-verba-blue dark:border-verba-blue-dk"
                  : "hover:bg-hover-effect hover:dark:bg-hover-effect-dk"
              }`}
              onClick={() => handleStepBackClick(step?.step)}
            >
              {filledStep >= step?.step ? (
                <CompletedIcon className="w-[15px] h-[15px] text-verba-green-success dark:text-verba-green-success-dk" />
              ) : (
                <div
                  className={`w-[15px] h-[15px] text-sm text-pure-white dark:text-pure-white-dk rounded-full flex flex-col items-center justify-center ${
                    createUserStep === step?.step
                      ? "bg-verba-blue dark:bg-verba-blue-dk"
                      : "bg-gray-250 dark:bg-gray-250-dk"
                  }`}
                >
                  {step?.step}
                </div>
              )}
              <span
                className={`text-md font-medium ${
                  filledStep >= step?.step
                    ? "text-heading-text dark:text-heading-text-dk"
                    : createUserStep === step?.step
                    ? "text-verba-blue dark:text-verba-blue-dk"
                    : "text-gray-placeholder dark:text-gray-placeholder-dk"
                }`}
              >
                {step?.title}
              </span>
            </div>
            {stepTitles?.length - 1 > index && (
              <div
                className={`w-[24px] h-[1px] mx-1 ${
                  filledStep >= step?.step
                    ? "bg-verba-green-success dark:bg-verba-green-success-dk"
                    : "bg-verba-blue dark:bg-verba-blue-dk"
                }`}
              />
            )}
          </React.Fragment>
        ))}
      </div>
      <button
        className="w-[16px] h-[16px] bg-gray-100 dark:bg-gray-100-dk rounded-full flex flex-col items-center justify-center"
        aria-label="close create user modal"
        onClick={handleCloseDrawer}
      >
        <CloseIcon className="w-[6px] h-[6px] text-verba-indigo dark:text-verba-indigo-dk" />
      </button>
    </div>
  );
};
